import { map, path, pipe, uniq } from 'ramda'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// eslint-disable-next-line import/prefer-default-export
export const getUniqueAuthors = pipe(map(path([`authorAlt`])), uniq)
